export default __webpack_public_path__ + "static/media/B134.881bf5e7.png";